var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"c-chat__userIndicator",class:[_setup.indicatorColorClass, _vm.small ? '-small' : '', _vm.medium ? '-medium' : '', _vm.large ? '-large' : '']})
}
var staticRenderFns = []

export { render, staticRenderFns }